export default () => ({
    articles: null,
    article: null,
    articlesConfig: {
        include: 'category,coverMedia,createdBy,translations',
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        per_page: 25,
        filters: {}
    },
    categories: null,
    categoriesConfig: {
        include: 'translations',
        sort: 'id',
        sortDirection: 'asc',
        page: 1,
        per_page: 100,
        filters: {}
    }
})
